const buttons = document.querySelectorAll('.js-newsletter-submit')
buttons.forEach((el) => {
    el.addEventListener('click', function(e) {
        // Selectors
        const form = e.target.closest('form');
        const email = form.querySelector('.js-email-input');

        // Email regex pattern
        var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // reset messages state
        form.querySelector('.error').style.display = 'none';
        form.querySelector('.success').style.display = 'none';

        // If the email is valid, submit the form, otherwise show error
        if (emailPattern.test(email.value)) {
            // Removing the error
            form.querySelector('.error').style.display = 'none';
            localStorage.setItem('form', form.id);
            form.submit();
        } else {
            // Showing the error
            form.querySelector('.error').style.display = 'block';
            form.querySelector('.js-subscribed-error').style.display = 'none';
        }
    });
});

if (window.location.search.includes('customer_posted=true')) {
    var formID = localStorage.getItem('form');
    var messages = document.querySelectorAll('.success');
    messages.forEach(el => {
        if (el.closest('.js-newsletter-form').id === formID) {
            el.style.display = 'block';
        }
    });
    document.querySelector('.site-footer__bottom').scrollIntoView({behavior: 'smooth'});
}

if (window.location.search.includes('form_type=customer')) {
    var formID = localStorage.getItem('form');
    var messages = document.querySelectorAll('.js-subscribed-error');
    messages.forEach(el => {
        if (el.closest('.js-newsletter-form').id === formID) {
            el.style.display = 'block';
        }
    });
    document.querySelector('.site-footer__bottom').scrollIntoView({behavior: 'smooth'});
}
